module.exports = __webpack_public_path__ + "img/hands_house.8d1876a.svg";